<template>
  <section>
    <v-dialog
      persistent
      v-model="dialog"
      transition="dialog-bottom-transition"
      width="600"
    >
      <v-card>
        <v-form v-model="valid" ref="form" lazy-validation>
          <!-- Cabecera del formulario -->
          <v-card-title class="headline">
            <v-flex xs9> <v-icon>mail</v-icon> NOTIFICACIÓN </v-flex>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-3">
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <h4 class="blue--text">
                  {{ falta.nombres }}
                </h4>
              </v-flex>
              <v-flex xs12 class="layout justify-center pb-4">
                <table class="tabla-faltas " id="tabla-faltas">
                  <tr>
                    <th>Fecha</th>
                    <th>Descripción</th>
                    <th>Horario</th>
                    <th>Hora marcada</th>
                    <th>Falta</th>
                  </tr>
                  <tr
                    v-for="marcado in falta.control_asistencia"
                    :key="marcado.id_persona"
                  >
                    <td style="width: 25%;">
                      {{ $moment(marcado.fecha_marcado).format("DD/MM/YYYY") }}
                    </td>
                    <td style="width: 25%;">
                      {{ marcado.descripcion ? marcado.descripcion : "-" }}
                    </td>
                    <td style="width: 25%;">
                      {{ marcado.horario ? marcado.horario : "-" }}
                    </td>
                    <td style="width: 25%;">
                      {{ marcado.hora_marcada ? marcado.hora_marcada : "-" }}
                    </td>
                    <td style="width: 25%;">
                      {{ marcado.detalle_marcado }}
                    </td>
                  </tr>
                </table>
              </v-flex>
              <v-flex>
                <v-btn
                  class="p-0 m-0"
                  color="#0085AD"
                  @click="notificarCorreo(falta)"
                  :loading="loading"
                  dark
                  block
                  title="Notificar faltas"
                >
                  <v-icon>mail</v-icon>
                  ENVIAR CORREO
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  props: [],
  components: {},
  // Variables iniciales del componente
  data() {
    return {
      dialog: false,
      valid: true,
      user: this.$storage.get("user"),
      loading: false,
      falta: {},
      parametros_notificacion: {}
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on(
      "openDialogNotificacionIndividual",
      (item, parametros_notificacion) => {
        this.falta = item;
        this.dialog = true;
        this.parametros_notificacion = parametros_notificacion;
      }
    );
  },
  // Métodos y funciones del componente
  methods: {
    // MEtodo para abrir o cerrar el dialog
    closeDialog() {
      this.falta = {};
      this.dialog = this.dialog ? false : true;
    },
    async notificarCorreo(item) {
      this.loading = true;
      // Generamos HTML tabla
      let tabla = this.generaTabla(item.control_asistencia);
      let mensaje = `
        <h1>NOTIFICACIÓN DE OBSERVACIONES EN EL REGISTRO DE ASISTENCIA</h1>
        <p>Sr(a).${item.nombres} </p>
        <p>Se comunica que usted ha incurrido en las siguientes faltas:</p>
        ${tabla}
        <br><br><br>
        <span style="color:rgba(2, 96, 202, 0.884)">De conformidad al parágrafo I, artículo 51 del Reglamento Interno de Personal Vigente y su modificación, su persona, a partir del día siguiente hábil de la presente notificación, deberá regularizar las observaciones realizadas (omisión, ausencia en el puesto de trabajo e inasistencia) en un plazo máximo 3 días, caso contrario se procederá a aplicar la sanción que corresponda.</span>
      `;

      let sw_envio = await this.$service.sendEmail({
        correo: item.correo,
        asunto: "NOTIFICACIÓN DE OBSERVACIONES EN EL REGISTRO DE ASISTENCIA",
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
      if (sw_envio) {
        // Guardamos historial de notificaciones
        await this.$query.add("historial_notificaciones", {
          id_persona: item.id_persona,
          faltas: this.parametros_notificacion.faltas,
          fecha_inicio: this.parametros_notificacion.fecha_inicio,
          fecha_fin: this.parametros_notificacion.fecha_fin,
          mensaje: mensaje,
          fecha_notificacion: new Date(),
          id_estado: 1,
          _user_created: this.user.id
        });
      }
      // LLamamos a actualizar el historial
      this.$bus.$emit("actualizaHistorialNotificacion");
      this.closeDialog();
      this.loading = false;
    },
    // Metodo para armar tabla de faltas
    generaTabla(faltas) {
      var cadena = "";
      faltas.forEach(element => {
        cadena += `
          <tr style="min-width: 100%;text-align: center;">
            <td style="width=16%">${this.$moment(element.fecha_marcado).format(
              "DD/MM/YYYY"
            )}</td>
            <td style="width=16%">${
              element.descripcion ? element.descripcion : "-"
            }</td>
            <td style="width=16%">${
              element.horario ? element.horario : "-"
            }</td>
            <td style="width=16%">${
              element.hora_marcada ? element.hora_marcada : "-"
            }</td>
            <td style="width=16%">${element.atraso ? element.atraso : "-"}</td>
            <td style="width=16%">${element.detalle_marcado}</td> 
          </tr>
         `;
      });
      var estilo_header = `style="height: 1em !important;color: rgba(2, 96, 202, 0.884);font-weight: bold;font-size: 0.9em;border-bottom: 1px solid rgba(2, 69, 156, 0.274);padding: 0px 0.2em 0px 0.2em !important;"`;
      var tabla = `
        <table style="min-width: 100%;font-family: 'Arial', sans-serif;">
          <tr>
            <th ${estilo_header}> Fecha</th>
            <th ${estilo_header}> Descripción</th>
            <th ${estilo_header}> Horario</th>
            <th ${estilo_header}> Hora que marcó</th>
            <th ${estilo_header}> Atraso</th>
            <th ${estilo_header}> Falta</th>
          </tr>
          ${cadena}
        </table>
      `;
      return tabla;
    }
  }
};
</script>
<style lang="scss" scoped>
.tabla-faltas {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.8em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.8em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/components/EnviaCorreoIndividual.vue